import { action, makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { bpHistory } from 'global/bpHistory';
import ElectionsModule from 'store/modules/elections/electionsModule';
import IFullFormPageStore from 'store/modules/full-employee-form/iFullFormPageStore';
import {
  BaseFullEmployeeFormDomainParams,
  FULL_FORM_TABS_WITH_ELECTIONS,
} from 'store/modules/full-employee-form/types';

export type FullEmployeeFormDomainParams = BaseFullEmployeeFormDomainParams;

export default class FullFormPageStore extends IFullFormPageStore<FullEmployeeFormDomainParams> {
  protected createElectionsModule(): ElectionsModule {
    return new ElectionsModule({
      groupId: this._domainData.groupId,
      enrollmentPeriodId: this._domainData.periodId,
    });
  }

  protected async _fetchCoreData(): Promise<void> {
    await Promise.all([
      this._electionsModule.getRequiredSubInfo(),
      this._electionsModule.getClasses(),
      this._electionsModule.getProducts(),
      this._electionsModule.getStatistics(),
    ]);
  }

  protected getPrimaryFormId(): string | undefined {
    return this._electionsModule.requiredSubInfo?.editSubFormId;
  }

  public onBackRedirect(): void {
    bpHistory.push(`/add-employees/${this._domainData.groupId}/${this._domainData.periodId}`);
  }

  constructor(domainData: FullEmployeeFormDomainParams) {
    super(domainData, FULL_FORM_TABS_WITH_ELECTIONS);

    makeObservable<FullFormPageStore, '_fetchCoreData'>(this, {
      onBackRedirect: action.bound,
      _fetchCoreData: action.bound,
    });
  }
}

const FullFormPageStoreContext = createContext(new FullFormPageStore({} as FullEmployeeFormDomainParams));

export const useFullFormPageStore = (): FullFormPageStore => {
  return useContext(FullFormPageStoreContext);
};

export { FullFormPageStoreContext };
